export const BUSINESS_REGIONS_TYPES = {
  emea: 'EMEA',
  americas: 'AMERICAS',
  asipacific: 'ASIPACIFIC',
};

export const BUSINESS_REGIONS = {
  'CA': 'AMERICAS',
  'US': 'AMERICAS',
  'RU': 'EMEA',
  'EG': 'EMEA',
  'ZA': 'EMEA',
  'GR': 'EMEA',
  'NL': 'EMEA',
  'BE': 'EMEA',
  'FR': 'EMEA',
  'ES': 'EMEA',
  'HU': 'EMEA',
  'IT': 'EMEA',
  'RO': 'EMEA',
  'CH': 'EMEA',
  'AT': 'EMEA',
  'GB': 'EMEA',
  'DK': 'EMEA',
  'SE': 'EMEA',
  'BV': 'EMEA',
  'NO': 'EMEA',
  'PL': 'EMEA',
  'DE': 'EMEA',
  'PE': 'AMERICAS',
  'MX': 'AMERICAS',
  'CU': 'AMERICAS',
  'AR': 'AMERICAS',
  'BR': 'AMERICAS',
  'CL': 'AMERICAS',
  'CO': 'AMERICAS',
  'VE': 'AMERICAS',
  'MY': 'ASIPACIFIC',
  'AU': 'ASIPACIFIC',
  'ID': 'ASIPACIFIC',
  'PH': 'ASIPACIFIC',
  'NZ': 'ASIPACIFIC',
  'PN': 'ASIPACIFIC',
  'SG': 'ASIPACIFIC',
  'TH': 'ASIPACIFIC',
  'JP': 'ASIPACIFIC',
  'KR': 'ASIPACIFIC',
  'VN': 'ASIPACIFIC',
  'CN': 'ASIPACIFIC',
  'TR': 'EMEA',
  'IN': 'ASIPACIFIC',
  'PK': 'ASIPACIFIC',
  'AF': 'ASIPACIFIC',
  'LK': 'ASIPACIFIC',
  'MM': 'ASIPACIFIC',
  'IR': 'EMEA',
  'SS': 'EMEA',
  'MA': 'EMEA',
  'EH': 'EMEA',
  'DZ': 'EMEA',
  'TN': 'EMEA',
  'LY': 'EMEA',
  'GM': 'EMEA',
  'SN': 'EMEA',
  'MR': 'EMEA',
  'ML': 'EMEA',
  'GN': 'EMEA',
  'CI': 'EMEA',
  'BF': 'EMEA',
  'NE': 'EMEA',
  'TG': 'EMEA',
  'BJ': 'EMEA',
  'MU': 'EMEA',
  'LR': 'EMEA',
  'SL': 'EMEA',
  'GH': 'EMEA',
  'NG': 'EMEA',
  'TD': 'EMEA',
  'CF': 'EMEA',
  'CM': 'EMEA',
  'CV': 'EMEA',
  'ST': 'EMEA',
  'GQ': 'EMEA',
  'GA': 'EMEA',
  'CG': 'EMEA',
  'CD': 'EMEA',
  'AO': 'EMEA',
  'GW': 'EMEA',
  'IO': 'ASIPACIFIC',
  'SC': 'EMEA',
  'SD': 'EMEA',
  'RW': 'EMEA',
  'ET': 'EMEA',
  'SO': 'EMEA',
  'DJ': 'EMEA',
  'KE': 'EMEA',
  'TZ': 'EMEA',
  'UG': 'EMEA',
  'BI': 'EMEA',
  'MZ': 'EMEA',
  'ZM': 'EMEA',
  'MG': 'EMEA',
  'RE': 'EMEA',
  'ZW': 'EMEA',
  'NA': 'EMEA',
  'MW': 'EMEA',
  'LS': 'EMEA',
  'BW': 'EMEA',
  'SZ': 'EMEA',
  'KM': 'EMEA',
  'VG': 'AMERICAS',
  'SH': 'EMEA',
  'ER': 'EMEA',
  'AW': 'AMERICAS',
  'FO': 'EMEA',
  'GL': 'EMEA',
  'GI': 'EMEA',
  'PT': 'EMEA',
  'LU': 'EMEA',
  'IE': 'EMEA',
  'IS': 'EMEA',
  'AL': 'EMEA',
  'MT': 'EMEA',
  'CY': 'EMEA',
  'AX': 'EMEA',
  'FI': 'EMEA',
  'BG': 'EMEA',
  'LT': 'EMEA',
  'LV': 'EMEA',
  'EE': 'EMEA',
  'MD': 'EMEA',
  'AM': 'EMEA',
  'BY': 'EMEA',
  'AD': 'EMEA',
  'MC': 'EMEA',
  'SM': 'EMEA',
  'VA': 'EMEA',
  'UA': 'EMEA',
  'RS': 'EMEA',
  'ME': 'EMEA',
  'XK': 'EMEA',
  'KV': 'EMEA',
  'HR': 'EMEA',
  'SI': 'EMEA',
  'BA': 'EMEA',
  'MK': 'EMEA',
  'CZ': 'EMEA',
  'SK': 'EMEA',
  'LI': 'EMEA',
  'FK': 'AMERICAS',
  'GS': 'AMERICAS',
  'BZ': 'AMERICAS',
  'GT': 'AMERICAS',
  'SV': 'AMERICAS',
  'HN': 'AMERICAS',
  'NI': 'AMERICAS',
  'CR': 'AMERICAS',
  'PA': 'AMERICAS',
  'PM': 'EMEA',
  'HT': 'AMERICAS',
  'GP': 'EMEA',
  'BL': 'EMEA',
  'MF': 'EMEA',
  'BO': 'AMERICAS',
  'GY': 'AMERICAS',
  'EC': 'AMERICAS',
  'GF': 'EMEA',
  'PY': 'AMERICAS',
  'TF': 'EMEA',
  'MQ': 'EMEA',
  'SR': 'AMERICAS',
  'UY': 'AMERICAS',
  'BQ': 'AMERICAS',
  'AN': 'AMERICAS',
  'TL': 'ASIPACIFIC',
  'AQ': 'AMERICAS',
  'BN': 'ASIPACIFIC',
  'NR': 'ASIPACIFIC',
  'PG': 'ASIPACIFIC',
  'TO': 'ASIPACIFIC',
  'SB': 'ASIPACIFIC',
  'VU': 'ASIPACIFIC',
  'FJ': 'ASIPACIFIC',
  'PW': 'ASIPACIFIC',
  'WF': 'EMEA',
  'CK': 'ASIPACIFIC',
  'NU': 'ASIPACIFIC',
  'WS': 'ASIPACIFIC',
  'KI': 'ASIPACIFIC',
  'NC': 'EMEA',
  'TV': 'ASIPACIFIC',
  'PF': 'EMEA',
  'TK': 'ASIPACIFIC',
  'FM': 'ASIPACIFIC',
  'MH': 'ASIPACIFIC',
  'KP': 'ASIPACIFIC',
  'HK': 'ASIPACIFIC',
  'MO': 'ASIPACIFIC',
  'KH': 'ASIPACIFIC',
  'LA': 'ASIPACIFIC',
  'BD': 'ASIPACIFIC',
  'TW': 'ASIPACIFIC',
  'MV': 'ASIPACIFIC',
  'LB': 'EMEA',
  'JO': 'EMEA',
  'SY': 'EMEA',
  'IQ': 'EMEA',
  'KW': 'EMEA',
  'SA': 'EMEA',
  'YE': 'EMEA',
  'OM': 'EMEA',
  'PS': 'EMEA',
  'AE': 'EMEA',
  'IL': 'EMEA',
  'BH': 'EMEA',
  'QA': 'EMEA',
  'BT': 'ASIPACIFIC',
  'MN': 'ASIPACIFIC',
  'NP': 'ASIPACIFIC',
  'TJ': 'EMEA',
  'TM': 'EMEA',
  'AZ': 'EMEA',
  'GE': 'EMEA',
  'KG': 'EMEA',
  'UZ': 'EMEA',
  'SX': 'AMERICAS',
  'LC': 'AMERICAS',
  'VC': 'AMERICAS',
  'KN': 'AMERICAS',
  'NF': 'ASIPACIFIC',
  'BS': 'AMERICAS',
  'BB': 'AMERICAS',
  'AI': 'AMERICAS',
  'AG': 'AMERICAS',
  'VI': 'AMERICAS',
  'KY': 'AMERICAS',
  'BM': 'AMERICAS',
  'GD': 'AMERICAS',
  'TC': 'AMERICAS',
  'JM': 'AMERICAS',
  'MS': 'AMERICAS',
  'MP': 'AMERICAS',
  'GU': 'AMERICAS',
  'AS': 'AMERICAS',
  'DM': 'AMERICAS',
  'PR': 'AMERICAS',
  'MI': 'AMERICAS',
  'WK': 'AMERICAS',
  'DO': 'AMERICAS',
  'TT': 'AMERICAS',
  'YT': 'EMEA',
  'GG': 'EMEA',
  'JE': 'EMEA',
  'IM': 'EMEA',
  'SJ': 'EMEA',
  'CW': 'AMERICAS',
  'CC': 'ASIPACIFIC',
  'CX': 'ASIPACIFIC',
  'KZ': 'EMEA',
};
